import React from "react";
import {Button} from 'primereact/button';

export default function MenuIcons(props) {

	if(props.section==="Utilizatori") {
		return(
			<Button label={props.section} icon="pi pi-users" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Nomenclator furnizori") {
		return(
			<Button label={props.section} icon="pi pi-verified" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Nomenclator produse") {
		return(
			<Button label={props.section} icon="pi pi-shopping-cart" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Nomenclator centre") {
		return(
			<Button label={props.section} icon="pi pi-building" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Necesare ANUALE") {
		return(
			<Button label={props.section} icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Nomenclator U.M.") {
		return(
			<Button label={props.section} icon="pi pi-sliders-v" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Dashboard") {
		return(
			<Button label={props.section} icon="pi pi-home" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Jurnal activitati") {
		return(
			<Button label={props.section} icon="pi pi-book" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Sabloane ANUALE") {
		return(
			<Button label={props.section} icon="pi pi-copy" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Nomenclator tipuri") {
		return(
			<Button label={props.section} icon="pi pi-database" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Contracte cadru") {
		return(
			<Button label={props.section} icon="pi pi-calendar" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Contracte subsecvente") {
		return(
			<Button label={props.section} icon="pi pi-calendar-plus" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Centralizator ANUAL") {
		return(
			<Button label={props.section} icon="pi pi-calculator" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Achizitii cu contract") {
		return(
			<Button label={props.section} icon="pi pi-check-square" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Achizitii directe") {
		return(
			<Button label={props.section} icon="pi pi-cart-plus" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Date unitate") {
		return(
			<Button label={props.section} icon="pi pi-building" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Necesare LUNARE") {
		return(
			<Button label={props.section} icon="pi pi-replay" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Sabloane LUNARE") {
		return(
			<Button label={props.section} icon="pi pi-bars" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Tipuri necesare LUNARE") {
		return(
			<Button label={props.section} icon="pi pi-database" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	if(props.section==="Note de comanda") {
		return(
			<Button label={props.section} icon="pi pi-align-justify" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
		);
	}
	return(
		<Button label={props.section} icon="pi pi-user" className="p-button-rounded p-button-text p-button-lg p-button-danger p-button-sm" style={{"width":"96%"}}/>
	);
}

